export default __webpack_public_path__ + "navigation-examples-electronic-horizon-thumbnail-480-6178c213a1a3f5b344f4266d0ced1c65.png";